import React from 'react';
import ReactEcharts from "echarts-for-react"; 
import echarts from 'echarts/lib/echarts';


export default function NestedPie({chartInfo, footerClick}) {  
  const onChartClick = (params) => {
    if (params.componentType === 'series') {
      footerClick(params.name);
    }
  };

  const onEvents = {
    'click': onChartClick,
  };

    return (  
        <ReactEcharts
          echarts={echarts}
          option={chartInfo}
          opts={{renderer: 'svg'}}
          style={{width: '50%', height: '350px'}}
          onEvents={onEvents}
        />
    )
}
